import { useState } from 'react';

export default function Hero() {
  const [showModal, setShowModal] = useState(false);

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-black">
      {/* 배경 이미지 */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/6aada410d307f5d5a4083438dc5a6848.jpg"
          alt="부산 네온 야경"
          className="w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/80"></div>
      </div>

      {/* 네온 글로우 원형 장식 */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 rounded-full opacity-10 pointer-events-none" style={{ background: 'radial-gradient(circle, #ec4899 0%, transparent 70%)', filter: 'blur(60px)' }}></div>
      <div className="absolute bottom-1/4 right-1/4 w-80 h-80 rounded-full opacity-10 pointer-events-none" style={{ background: 'radial-gradient(circle, #06b6d4 0%, transparent 70%)', filter: 'blur(60px)' }}></div>

      {/* 전화/문자 선택 모달 */}
      {showModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center"
          style={{ background: 'rgba(0,0,0,0.7)' }}
          onClick={() => setShowModal(false)}
        >
          <div
            className="rounded-2xl p-6 w-72 flex flex-col gap-4"
            style={{ background: '#1a1a1a', border: '1px solid rgba(236,72,153,0.4)', boxShadow: '0 0 40px rgba(236,72,153,0.3)' }}
            onClick={(e) => e.stopPropagation()}
          >
            <p className="text-center text-white font-semibold text-lg tracking-wide">예약 방법 선택</p>
            <a
              href="tel:01057815340"
              className="flex items-center justify-center gap-3 py-4 rounded-full font-semibold text-black transition-all whitespace-nowrap cursor-pointer"
              style={{ background: 'linear-gradient(135deg, #ec4899, #f97316)', boxShadow: '0 0 20px rgba(236,72,153,0.5)' }}
              onClick={() => setShowModal(false)}
            >
              <span className="w-5 h-5 flex items-center justify-center"><i className="ri-phone-fill text-lg"></i></span>
              전화 통화
            </a>
            <a
              href="sms:01057815340"
              className="flex items-center justify-center gap-3 py-4 rounded-full font-semibold text-pink-400 border border-pink-500 hover:bg-pink-500 hover:text-black transition-all whitespace-nowrap cursor-pointer"
              style={{ boxShadow: '0 0 15px rgba(236,72,153,0.3)' }}
              onClick={() => setShowModal(false)}
            >
              <span className="w-5 h-5 flex items-center justify-center"><i className="ri-message-2-fill text-lg"></i></span>
              문자 메시지
            </a>
            <button
              className="text-gray-500 text-sm mt-1 hover:text-gray-300 transition-colors cursor-pointer"
              onClick={() => setShowModal(false)}
            >
              닫기
            </button>
          </div>
        </div>
      )}

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-8 text-left pt-24 md:pt-0">
        <div className="space-y-3 md:space-y-4">
          <p
            className="text-sm md:text-lg font-medium tracking-[0.3em] md:tracking-[0.4em] uppercase"
            style={{ color: '#06b6d4', textShadow: '0 0 12px #06b6d4, 0 0 24px #06b6d4' }}
          >
            Premium Entertainment
          </p>
          <h1
            className="text-6xl md:text-8xl font-black leading-none tracking-tight"
            style={{ fontFamily: "'Orbitron', sans-serif", color: '#fff', textShadow: '0 0 20px rgba(236,72,153,0.8), 0 0 40px rgba(236,72,153,0.4)' }}
          >
            부산<br />
            <span style={{ color: '#ec4899', textShadow: '0 0 20px #ec4899, 0 0 40px #ec4899, 0 0 80px #ec4899' }}>호스트바</span>
          </h1>
          <p className="text-lg md:text-2xl text-gray-300 font-light tracking-widest">
            최고의 서비스 · 특별한 밤
          </p>
        </div>

        <p className="mt-6 md:mt-8 text-sm md:text-base text-gray-400 font-light max-w-xl leading-relaxed">
          특별한 밤을 위한 프리미엄 엔터테인먼트.<br />
          세련된 호스트들과 함께 잊지 못할 시간을 경험하세요.
        </p>

        <div className="mt-8 md:mt-12 flex flex-col sm:flex-row gap-4">
          <button
            onClick={() => setShowModal(true)}
            className="px-8 py-4 rounded-full font-semibold text-black transition-all whitespace-nowrap cursor-pointer text-center"
            style={{ background: 'linear-gradient(135deg, #ec4899, #f97316)', boxShadow: '0 0 20px rgba(236,72,153,0.6), 0 0 40px rgba(236,72,153,0.3)' }}
          >
            바로 예약하기
          </button>
          <a
            href="tel:01057815340"
            className="px-8 py-4 rounded-full font-semibold text-pink-400 border border-pink-500 hover:bg-pink-500 hover:text-black transition-all whitespace-nowrap cursor-pointer text-center"
            style={{ boxShadow: '0 0 15px rgba(236,72,153,0.3)' }}
          >
            전화문의
          </a>
        </div>

        {/* 스크롤 인디케이터 */}
        <div className="mt-12 md:mt-20 flex items-center gap-3">
          <div className="w-8 h-px" style={{ background: '#ec4899', boxShadow: '0 0 6px #ec4899' }}></div>
          <span className="text-xs text-gray-500 tracking-widest uppercase">Scroll Down</span>
        </div>
      </div>
    </section>
  );
}
